import { EntrataApplicationStatus, RelationshipType } from '@common/entities';

import { ApplicationStatusResponse } from 'services/applicant';

export const sortApplications = (
  applications: ApplicationStatusResponse[],
): ApplicationStatusResponse[] => {
  const isActive = (status: EntrataApplicationStatus) =>
    [EntrataApplicationStatus.Started, EntrataApplicationStatus.PartiallyCompleted].includes(
      status,
    );

  const isCompleted = (status: EntrataApplicationStatus) =>
    [
      EntrataApplicationStatus.Completed,
      EntrataApplicationStatus.Approved,
      EntrataApplicationStatus.ConditionallyApproved,
    ].includes(status);

  const isInactive = (status: EntrataApplicationStatus) =>
    [
      EntrataApplicationStatus.Expired,
      EntrataApplicationStatus.Archived,
      EntrataApplicationStatus.Denied,
      EntrataApplicationStatus.Cancelled,
    ].includes(status);

  const hasApplicantCompleted = (app: ApplicationStatusResponse) => !!app.applicantCompletedOn;

  const priorityOrder: RelationshipType[] = [
    RelationshipType.Primary,
    RelationshipType.Guarantor,
    RelationshipType.Coapplicant,
  ];

  const categorySort = (
    apps: ApplicationStatusResponse[],
    statusCheck: (status: EntrataApplicationStatus) => boolean,
    completed: boolean,
  ) =>
    priorityOrder.flatMap((role) =>
      apps.filter(
        (app) =>
          app.relationshipType === role &&
          statusCheck(app.applicationStatus) &&
          hasApplicantCompleted(app) === completed,
      ),
    );

  return [
    ...categorySort(applications, isActive, false),
    ...categorySort(applications, isActive, true),
    ...categorySort(applications, isCompleted, true),
    ...categorySort(applications, isInactive, false),
    ...categorySort(applications, isInactive, true),
  ];
};
